import { Action } from 'redux';

import { ResourceGovernanceResetSiteToDefaults } from '~src/bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '~src/bootstrap/redux/actions/isActionFactory';
import { Messages } from '~src/codegen/Localize';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { IResourceGovernanceSiteSetting } from '../types/ResourceGovernance';

// Everything is set up so we can ask the backend if the action is allowed
// which means that we need to use an "action allowed payload"
export interface IResourceGovernanceResetSiteToDefaultsAction {
  resetSiteResourceGovernanceSite: boolean;
}

// The action itself. Which contains if it's allowed.
export const ResourceGovernanceResetSiteToDefaultsAction: IEntityAction<IResourceGovernanceSiteSetting, IResourceGovernanceResetSiteToDefaultsAction> = {
  name: EntityActionNames.ResourceGovernanceResetSiteToDefaultsAction,
  translateName: Messages.resourceGovernanceResetSiteToDefaultsAction,
  isVisible: () => true,
  isClickable: (availableActions: IResourceGovernanceResetSiteToDefaultsAction) => !!(availableActions && availableActions.resetSiteResourceGovernanceSite),
  createReduxAction: (targetItems: IResourceGovernanceSiteSetting[]) => resetSiteToDefaultsAction(targetItems.map(s => s.siteId), targetItems),
};

export interface ResourceGovernanceResetSiteToDefaultsAction extends Action {
  siteIds: string[];
  settings: Partial<IResourceGovernanceSiteSetting>[];
}

export function resetSiteToDefaultsAction(siteIds: string[], settings: Partial<IResourceGovernanceSiteSetting>[]): ResourceGovernanceResetSiteToDefaultsAction {
  return {
    type: ResourceGovernanceResetSiteToDefaults,
    siteIds,
    settings,
  };
}

export const isResetSiteToDefaultsAction = isActionFactory<ResourceGovernanceResetSiteToDefaultsAction>(ResourceGovernanceResetSiteToDefaults);
